import React from "react";
import clsx from "clsx";
import dayjs from "dayjs";
import { Checkbox } from "antd";

import { RECORD_TYPES } from "../common/recordTypes";
import { TypeBadge, PriorityBadge } from "../common/ActivityBadges";

import styles from "./ActivityListItem.module.scss";

const recordSummaryText = (activity) => {
  const cfg = RECORD_TYPES[activity.record_type];
  if (!cfg) return null;

  const label = activity.record ? cfg.renderLabel(activity.record) : null;
  const value = label || `${activity.record_id}`;
  // Some record labels already include the type (e.g. "Ticket 1"); drop the
  // leading type so it reads "Ticket: 1" rather than "Ticket: Ticket 1".
  const deduped =
    value === `${cfg.label} ${activity.record_id}`
      ? `${activity.record_id}`
      : value;
  return `${cfg.label}: ${deduped}`;
};

const ActivityListItem = ({
  activity,
  onClick,
  onToggleDone,
  dimDone = true,
}) => {
  const summary = recordSummaryText(activity);
  const dueAt = activity.due_at
    ? dayjs(activity.due_at).format("YYYY-MM-DD HH:mm")
    : "-";

  return (
    <div
      className={clsx(styles.item, {
        [styles.itemDone]: dimDone && activity.done,
      })}
    >
      <div className={styles.itemMain} onClick={() => onClick?.(activity)}>
        <div className={styles.itemTopRow}>
          <TypeBadge type={activity.type} />
          <PriorityBadge priority={activity.priority} />
          <span className={styles.itemTitle}>{activity.title}</span>
        </div>
        <div className={styles.itemBottomRow}>
          {summary ? `${summary} | ${dueAt}` : dueAt}
        </div>
      </div>
      <div
        className={styles.doneSection}
        onClick={() => onToggleDone?.(activity, !activity.done)}
      >
        <Checkbox
          checked={!!activity.done}
          onClick={(e) => e.stopPropagation()}
          onChange={(e) => onToggleDone?.(activity, e.target.checked)}
        />
      </div>
    </div>
  );
};

export default ActivityListItem;
